module.exports = __webpack_public_path__ + "img/downAppCode1.6b973771.png";